import script from "./yzjy.vue?vue&type=script&setup=true&lang=js"
export * from "./yzjy.vue?vue&type=script&setup=true&lang=js"

import "./yzjy.vue?vue&type=style&index=0&id=e1b86dd8&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1b86dd8"]])

export default __exports__